<template>
  <div>
    <div>
      <img style="width: 100%;height: auto;"v-lazy="img1">
      <img style="width: 100%;height: auto;" v-lazy="img2">

      <img style="width: 100%;height: auto;" v-lazy="img3">

      <img style="width: 100%;height: auto;" v-lazy="img4">
      <img style="width: 100%;height: auto;" v-lazy="img5">
      
      <img style="width: 100%;height: auto;" v-lazy="img6">
      <img style="width: 100%;height: auto;" v-lazy="img7">
    </div>
    <div class="footer2"></div>
    <div class="footer">
      <!-- hahhah -->
          <div>
            <a :href="'tel:' + '153-0060-8364'" style="display: block;background-color: none;-webkit-tap-highlight-color:transparent;">
              <img style="width: 55.63px; height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF-10.png">
            </a>
          </div>

          <div @click="dialogVisible = true" style="-webkit-tap-highlight-color:transparent;">
            <img style="width: 55.63px; height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF-09.png">
          </div>

          <div>
            <a :href="'tel:' + '153-0060-8364'" style="display: block;background-color: none;-webkit-tap-highlight-color:transparent;">
              <img style="width: 240px; height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF-11.png">
            </a>
          </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="290px"
      class="dialogS"
      >
        <!-- <span slot="title">请长按图片保存</span> -->
        <span style="margin-top: 10px;display: block;">方式1：长按二维码保存在本机，使用微信“扫一扫”添加好友</span>
        <div  style="height: 150px;width: 150px;margin: 10px auto;" @touchstart="touchStart()" @touchend="touchEnd()">
          <img style="height: 150px;width: 150px;" :src="qrcodeUrl">
        </div>

        <span>方式2：微信直接搜索手机号(15300608364)添加好友</span>
        
    </el-dialog>
  </div>
  <!-- <div class="follow_bc"> -->
    <!-- <div class="tab_two">
        <div
            @click="tabClick(item.id, i)"
            v-for="(item, i) in tabsList"
            :key="i"
            ref="label"
            :class="item.id === groupId ? 'active' : ''"
            class="second_tab"
        >
            {{ item.name }}
        </div>
    </div>
    <div class="bottom_line" v-if="tabsList.length"></div>
    <div v-show="groupId === 0"> 
      <img style="width: 100%;height: auto;" src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%204.png">
      <img  style="width: 100%;height: auto;margin: 0 auto;display: block;object-fit: contain;"  src="https://zy-1308102271.file.myqcloud.com/YmyImg%2Fhome%2F20240427%E6%98%93%E7%BE%8E%E4%BA%91_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%206.png">
    </div>
    <div v-show="groupId === 1">2内容</div>
    <div v-show="groupId === 2">3内容</div> -->
  <!-- </div> -->
  
  <!-- <div class="body_mb">
   

  </div> -->

</template>

<script>
export default {
  name: 'mbindex',
  data() {
      return {
        img1:'https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF_%E7%94%BB%E6%9D%BF%201.png',
        img2:'https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC.png',
        img3:'https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%202.png',
        img4:'https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%203.png',
        img5:'https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%204.png',
        // img6:'https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%205.png',
        img6:'https://zy-1308102271.file.myqcloud.com/YmyImg%2F%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240815153029.png',
        img7:'https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF_%E7%94%BB%E6%9D%BF%201%20%E5%89%AF%E6%9C%AC%206.png',
        img8:'',
        tabsList: [
                { name: 'tab1', id: 0 },
                { name: 'tab2', id: 1 },
                { name: 'tab3', id: 2 },
            ], //tabs的数组
        groupId: 0,
        dialogVisible:false,
        qrcodeUrl: 'https://zy-1308102271.file.myqcloud.com/YmyImg%2Fedition%2F%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240624173248.jpg',
        qrcodeUrl64:'',
        timer:''
      };
    },
  
  props: {
    msg: String
  },
  
  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // goToBaidu() {
      
    //   window.open('http://saas.ymeicloud.com/');
    // },
    // tabClick(id, i) {
    //         this.groupId = id;
    //         let doc = document.getElementsByClassName('bottom_line')[0];
    //         let left = this.$refs.label[i].offsetLeft + 'px'; //返回当前元素的相对水平偏移位置的偏移容器
    //        let width = this.$refs.label[i].clientWidth + 'px'; //	在页面上返回内容的可视宽度（不包括边框，边距或滚动条）
    //         doc.style.width = `${width}`;
    //         doc.style.transform = `translateX(${left})`;
    //         doc.style.transition = '.3s';
    //     },
    touchEnd() {
      //手指离开
      clearTimeout(this.timer);
    },
    touchStart() {
      //手指触摸
      clearTimeout(this.timer); //再次清空定时器，防止重复注册定时器
      this.timer = setTimeout(() => {
        this.downloadIamge(this.qrcodeUrl64, "pic");
      }, 1000);
    },
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
  },

}
</script>
<style scoped>
.follow_bc {
    width: 100%;
    margin-top: 10px;
    position: relative;
}
.first_tab {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    cursor: pointer;
}
.bottom_line {
    width: 93px;
    height: 2px;
    background: linear-gradient(137deg, #ff9696 0%, #e55653 100%);
    box-shadow: 0px 1px 4px 0px rgba(215, 6, 3, 0.19);
    border-radius: 1px;
    border: 0px solid rgba(151, 151, 151, 0);
    position: absolute;
    margin-top: -9px;
    margin-left: 1px;
   
}
.second_tab {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    cursor: pointer;
    width: 93px;
    display: flex;
    justify-content: center;
}
 
 
 
.tab_two {
    display: flex;
    padding: 20px 0px;
    justify-content: space-between;
}
.tab_two div.active {
    color: #333;
    font-size: 20px;
    letter-spacing: 1px;
}

.footer{
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 63px; /* 根据需要设置高度 */
  background-image: url('https://zy-1308102271.file.myqcloud.com/YmyImg%2FmbImg%2F20240703%E6%98%93%E7%BE%8E%E4%BA%91-%E7%A7%BB%E5%8A%A8%E7%AB%AF-08.png'); /* 设置背景图 */
  background-size: cover; /* 背景图覆盖整个元素区域 */
  background-position: center; /* 背景图居中 */
  background-repeat: no-repeat; /* 背景图不重复 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
}

.footer2{
  width: 100%;
  height: 63px;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
}

/deep/ .dialogS .el-dialog{
  background:#F2F0FE;
  border-radius:15px;
  
}

/deep/ .dialogS  .el-dialog__header{
  padding: 0;
}

/deep/ .dialogS .el-dialog__body{
  color: black;
  font-size: 15px;
  margin: 0 auto;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

</style>
